import './App.css';
import {ThemeProvider} from "styled-components";
import GlobalStyle from "./styles/GlobalStyle";
import route from "./routes";
import theme from "./styles/theme";
import initializeApp from "./app/init";
import {StoreProvider} from "./app/store";
import {getLocalState} from "./app/editor/utils/localState";
import "./styles/FontSetting.css"


initializeApp()

function App() {
    const isDev = process.env.NODE_ENV !== 'production';
    const root = document.getElementById('root');
    const initialState = {
        localSettingsStore: getLocalState(),
        appEditorStore: {
            isDev,
            rootEl: root,
            updateAppShell: true,
        }
    };
    return (
        <StoreProvider initialState={initialState}>
            <ThemeProvider theme={theme}>
                <GlobalStyle/>
                {route()}
            </ThemeProvider>
        </StoreProvider>
    );
}

export default App;
